import { render, staticRenderFns } from "./TwitterArchiveUploader.vue?vue&type=template&id=f1c5f53a&scoped=true&"
import script from "./TwitterArchiveUploader.vue?vue&type=script&lang=js&"
export * from "./TwitterArchiveUploader.vue?vue&type=script&lang=js&"
import style0 from "./TwitterArchiveUploader.vue?vue&type=style&index=0&id=f1c5f53a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c5f53a",
  null
  
)

export default component.exports